import { css } from 'styled-components'

export const TOPBAR_HEIGHT = 45
const STATUS_BAR_HEIGHT = 24

export const layoutHeightCss = css`
  height: calc(100cqh - ${TOPBAR_HEIGHT + STATUS_BAR_HEIGHT}px);
  max-height: calc(100cqh - ${TOPBAR_HEIGHT + STATUS_BAR_HEIGHT}px);
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;
`
